"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandModelToJSON = exports.HandModelFromJSONTyped = exports.HandModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function HandModelFromJSON(json) {
    return HandModelFromJSONTyped(json, false);
}
exports.HandModelFromJSON = HandModelFromJSON;
function HandModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fingers': (json['fingers'].map(_1.FingerDescriptionFromJSON)),
        'amputated': json['amputated'],
        'fingerPrints': !runtime_1.exists(json, 'fingerPrints') ? undefined : _1.FingerprintModelFromJSON(json['fingerPrints']),
    };
}
exports.HandModelFromJSONTyped = HandModelFromJSONTyped;
function HandModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fingers': (value.fingers.map(_1.FingerDescriptionToJSON)),
        'amputated': value.amputated,
        'fingerPrints': _1.FingerprintModelToJSON(value.fingerPrints),
    };
}
exports.HandModelToJSON = HandModelToJSON;
//# sourceMappingURL=HandModel.js.map